import React from 'react'
import { Select } from 'antd'


const path = window.location.pathname
const inputType = path === '/onboarding/investment-detail' ? null: '100%'

const SelectFieldComponent = ({ input, meta, children, refProps, ...custom }) => {
  const { value, onChange, onBlur, defaultValue } = input
  const { error, touched } = meta
  const hasError = touched && error !== undefined
  const { placeholder } = custom

  return (
    <div style={{width: inputType}} className={hasError ? 'has-error' : ''}>
      <Select
        value={value ? value : placeholder}
        onChange={onChange}
        defaultValue={defaultValue}
        onBlur={onBlur}
        {...custom}
        ref={refProps}
      >
        {children}
      </Select>
    </div>
  )
}
export default SelectFieldComponent
